import React from 'react';

const FlowContext = React.createContext();

export const { Provider, Consumer } = FlowContext;
export default FlowContext;
